import { useMutation } from '@tanstack/react-query';
import ChatService from '../services/chat.service';

const chatService = new ChatService();

/**
 * Custom hook to upload a file using React Query's mutation.
 *
 * @returns An object containing the mutation state and the `mutate` function to trigger the upload.
 */
export const useRateConversation = () => {
    return useMutation({
        mutationFn: ({
            conversationId,
            interactionId,
            rating,
            feedbackComment,
            agent_version,
        }: {
            conversationId: string;
            interactionId: string;
            rating: 'positive' | 'negative';
            feedbackComment: string;
            agent_version: string;
        }) => chatService.rateResponse(conversationId, interactionId, rating, feedbackComment, agent_version),
    });
};

export default useRateConversation;
